import ConfigPerTemplateTypes from 'store/actionTypes/configPerTemplate'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  current: {}
}

const ConfigPerTemplate = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ConfigPerTemplateTypes.GET_CONFIG_PER_TEMPLATES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ConfigPerTemplateTypes.GET_CONFIG_PER_TEMPLATE_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload || {}
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default ConfigPerTemplate
